import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import {
  clearChapters,
  createChapter,
  deleteChapter,
  editChapter,
  getChapters,
} from "../actions/chapters";
import { CHAPTER } from "../@types";

interface CHAPTERS_INITIAL_STATE {
  chapters: CHAPTER[];
  status: "idle" | "pending" | "succeeded" | "failed";
  error: any;
}

const initialState: CHAPTERS_INITIAL_STATE = {
  chapters: [],
  status: "idle",
  error: null,
};

const chaptersSlice = createSlice({
  name: "chapters",
  initialState,
  reducers: {},

  extraReducers(builder: ActionReducerMapBuilder<CHAPTERS_INITIAL_STATE>) {
    const normId = (v: string | number) => String(v);
    builder.addCase(getChapters.rejected, (_state, action) => ({
      ...initialState,
      status: "failed",
      error: action.error.message,
    }));
    builder.addCase(getChapters.fulfilled, (_state, action) => ({
      chapters: action.payload,
      error: null,
      status: "succeeded",
    }));
    builder.addCase(createChapter.fulfilled, (state, action) => {
      const { chapter } = action.payload;
      const newArr = JSON.parse(JSON.stringify(state.chapters));
    newArr.push(chapter);
      state.chapters = newArr;
    });
    builder.addCase(createChapter.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || action.error.message; // Store the error message in the state for further use
    });
    builder.addCase(deleteChapter.fulfilled, (state, action) => {
      const chapterId = action.payload;
      const idx = state.chapters.findIndex((p) => normId(p.id) === normId(chapterId));
      if (idx !== -1) state.chapters.splice(idx, 1);
    });
    builder.addCase(clearChapters.fulfilled, () => ({ ...initialState }));
    builder.addCase(editChapter.fulfilled, (state, action) => {
      const updated = action.payload as CHAPTER | null | undefined;
      if (!updated || updated.id == null) return;

      const idx = state.chapters.findIndex(
        (c) => c && normId(c.id) === normId(updated.id)
      );
      if (idx === -1) {
      // Do NOT insert on edit — preserves order. Bail out silently.
      return;
    }
    // keep position, just replace fields
    state.chapters[idx] = { ...state.chapters[idx], ...updated };
});
    builder.addCase(editChapter.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || action.error.message;
    });
  },
});

export default chaptersSlice.reducer;
